'use client'

import { Button } from '@algoacademy/design-system/web/actions/Button'
import { showErrorToastWithAlgoPhoneNumber } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError'
import { Input } from '@algoacademy/design-system/web/forms/Input'
import { H3 } from '@algoacademy/design-system/web/marketing/typography/Heading'
import { P3 } from '@algoacademy/design-system/web/marketing/typography/Paragraph'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { useTRPC } from '@/app/_trpc/config'

type NewsletterForm = {
  email: string
}

export function Newsletter() {
  const trpc = useTRPC()
  const subscribeNewsletterMutation = useMutation(
    trpc.notifications.subscribeNewsletter.mutationOptions()
  )
  const { register, handleSubmit, reset } = useForm<NewsletterForm>()

  const onSubmit = async (data: NewsletterForm) => {
    try {
      await subscribeNewsletterMutation.mutateAsync({ email: data.email })
      toast.success('Udało się!', {
        description: 'Dziękujemy za zapisanie się do naszego newslettera!'
      })
      reset()
    } catch {
      showErrorToastWithAlgoPhoneNumber()
    }
  }

  return (
    <div className='space-y-4'>
      <H3>Bądź na bieżąco z rozwojem naszej platformy</H3>
      <P3>Zapisz się do naszego newslettera</P3>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className='flex flex-col items-center gap-4 lg:flex-row'
      >
        <Input
          placeholder='Email'
          type='email'
          {...register('email', { required: true })}
          className='h-full'
        />
        <Button size='xl' type='submit' className='w-full text-nowrap lg:w-fit'>
          Zapisz się
        </Button>
      </form>
    </div>
  )
}
